import * as React from 'react';
import useOrientation from 'lib/hooks/useOrientation';
import './index.scss';

interface ImageProps {
  portraitBackgroundImg: string;
  landscapeBackgroundImg: string;
}

export default function Image({ data }: { data: ImageProps }) {
  const { portraitBackgroundImg, landscapeBackgroundImg } = data;
  const  { isLandscape }  = useOrientation();

  const imgSrc = React.useMemo(() => (isLandscape ? landscapeBackgroundImg : portraitBackgroundImg), [
    isLandscape,
    portraitBackgroundImg,
    landscapeBackgroundImg,
  ]);

  return (
    <div className='impage-material-image-container'>
      <img className='impage-material-image' src={imgSrc} alt='[图片]' />
    </div>
  );
}
